(function () {
    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../metrics/facebookAds.js'),
            require('lodash')
        );

    } else {

        RivalIQ.apps.AdsInsights.data.CustomConversionMetrics = exportFn(
            RivalIQ.metrics.definitions.facebookAds,
            window._
        );
    }


    function exportFn(facebookAds, _) {

        function buildCustomConversionMetrics(adAccountId, customConversions) {
            return _.reduce(customConversions, function (memo, customConversion) {
                const newCustomMetrics = {};

                // number of events
                newCustomMetrics[`actions_offsite_conversion__custom__${customConversion.id}`] = _.defaults({
                    name: customConversion.name,
                    description: `The number of "${customConversion.name}" events tracked by the pixel on your website and attributed to your ads.`,
                    applicableAccountId: adAccountId
                }, facebookAds.actions_offsite_conversion);

                // cost per event
                newCustomMetrics[`cost_per_action_type_offsite_conversion__custom__${customConversion.id}`] = _.defaults({
                    name: `Cost per ${customConversion.name}`,
                    description: `The Cost per "${customConversion.name}" event.`,
                    applicableAccountId: adAccountId
                }, facebookAds.cost_per_action_type_offsite_conversion);

                // total value of all the events
                newCustomMetrics[`action_values_offsite_conversion__custom__${customConversion.id}`] = _.defaults({
                    name: `${customConversion.name} Value`,
                    description: `The value of "${customConversion.name}" events from your ads.`,
                    applicableAccountId: adAccountId
                }, facebookAds.action_values_offsite_conversion);

                return _.extend(newCustomMetrics, memo);
            }, {});
        }

        return {
            buildCustomConversionMetrics: buildCustomConversionMetrics
        };
    }
})();
